<template>
	<div>
		<div class="notification-description-wrapper">
			<div class="notification-description">
				{{ $translate("Eros::Template.articleNotificationDescription") }}
			</div>
			<div class="form-group input-unit">
				<input
					type="email"
					class="form-control"
					id="itemNotificationMail"
					:value="mail"
					@input="mail = $event.target.value"
				/>
				<label for="itemNotificationMail">E-Mail</label>
			</div>
			<div class="form-check add-to-basket-container">
				<label class="form-check-label">
					<input type="checkbox" class="form-check-input" value="gtc" id="gtc-accept" v-model="isChecked" />
					<small v-html="labelHtml" class="form-text text-muted"></small>
				</label>
				<button class="btn btn-block btn-primary" @click="addArticleNotification">
					<i aria-hidden="true" class="fa fa-envelope"></i>{{ $translate("Eros::Template.articleNotificationButton") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import TranslationService from "../../../ceres/services/TranslationService";
import NotificationService from "../../../ceres/services/NotificationService";
import ApiService from "../../../ceres/services/ApiService";

export default {
    name: "add-article-notification",

	inject: {
		itemId: {
			default: null
		}
	},

    data()
    {
        return {
            mail: '',
            isChecked: false
        };
    },

	computed: {
		currentVariation() {
			return this.$store.getters[`${this.itemId}/currentItemVariation`];
		},

		labelHtml()
        {
            const contactPrivacyPolicy = this.$translate("Ceres::Template.checkoutPrivacyPolicy", {"hyphen": "&shy;"});
            const html = `
                <!----><a href="${ App.urls.privacyPolicy }" target="_blank" class="text-appearance">
                    <span>${ contactPrivacyPolicy }</span>
                </a><!---->
            `;

            return this.$translate("Eros::Template.checkoutPolicy", {policy: html});
        }
	},

    methods: {
        addArticleNotification: function()
        {
            if(this.isChecked)
            {
                var re = /\S+@\S+\.\S+/;
                
                if (re.test(this.mail))
                {
                    ApiService.post("/rest/erosbackend/item/articleNotification/", {
                        mail: this.mail,
                        variationID: this.currentVariation.id,
                        title: this.currentVariation.texts.name1,
                        lang: App.language
                    })
                    .done(
                    response =>
                    {
                        if("status" in response)
                        {
                            if(response["status"] == "success")
                            {
                                NotificationService.success(TranslationService.translate("Eros::Template." + response.message.toString())).closeAfter(8000);
                            }

                            if(response["status"] == "error")
                            {
                                if("details" in response)
                                {
                                    NotificationService.error(TranslationService.translate("Eros::Template." + response.message.toString()).replace("<details>", response.details.toString())).closeAfter(5000);
                                }
                                else
                                {
                                    NotificationService.error(TranslationService.translate("Eros::Template." + response.message.toString())).closeAfter(5000);
                                }
                            }
                        }
                    });
                }
                else
                {
                    NotificationService.error(TranslationService.translate("Eros::Template.errorInvalidMail")).closeAfter(5000);
                }
            }
            else
            {
                NotificationService.error(TranslationService.translate("Eros::Template.errorGTC")).closeAfter(5000);
            }
        }
    }
};
</script>